// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MyClients.scss */
:root {
  --text-color: #374151;
  --light-gray: #f3f4f6;
  --medium-gray: #e5e7eb;
  --border-color: #d1d5db;
  --card-bg: #ffffff;
  --shadow-light: rgba(0, 0, 0, 0.05);
  --shadow-medium: rgba(0, 0, 0, 0.08);
}

.my-clients-wrapper .filter-group label {
  display: block;
  margin-bottom: 8px;
}
.my-clients-wrapper .view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.my-clients-wrapper .view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.my-clients-wrapper .view-toggle-wrapper .view-toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.my-clients-wrapper .view-toggle-wrapper .view-toggle-btn:hover {
  background-color: #f3f4f6;
}
.my-clients-wrapper .view-toggle-wrapper .view-toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.my-clients-wrapper .clients-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 1rem;
  padding: 15px;
  background-color: #f8f9fa;
  box-sizing: border-box;
  margin-top: 1rem;
}
.my-clients-wrapper .clients-container .clients-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light);
}
.my-clients-wrapper .clients-container .clients-table thead {
  background-color: #f1f5f9;
}
.my-clients-wrapper .clients-container .clients-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
}
.my-clients-wrapper .clients-container .clients-table tbody tr {
  transition: background-color 0.2s ease;
}
.my-clients-wrapper .clients-container .clients-table tbody tr:hover {
  background-color: #f9fafb;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td {
  padding: 0.9rem 1rem;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td:last-child {
  white-space: nowrap;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td:last-child button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #17a2b8;
  color: white;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td:last-child button:last-child {
  background-color: #dc2626;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td:last-child button:hover {
  opacity: 0.9;
}
.my-clients-wrapper .clients-container .client-card-main {
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  padding: 1rem;
  position: relative;
}
.my-clients-wrapper .clients-container .client-card-main .client-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed var(--medium-gray);
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions {
  position: relative;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .client-action-button {
  background-color: var(--primary-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 8px 12px;
  font-size: 0.8rem;
  color: var(--text-color);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .client-action-button:hover {
  box-shadow: 0 1px 4px var(--shadow-medium);
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .client-action-button svg {
  font-size: 1.1rem;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu {
  position: absolute;
  top: 3rem;
  right: 0;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  min-width: 180px;
  z-index: 100;
  list-style: none;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li {
  padding: 0.75rem 1.2rem;
  font-size: 0.9rem;
  color: var(--text-color);
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li:hover {
  background-color: var(--light-gray);
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li:not(:last-child) {
  border-bottom: 1px solid var(--medium-gray);
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li.view {
  color: #2563eb;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li.update {
  color: #10b981;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li.delete {
  color: #ef4444;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li.message {
  color: #8b5cf6;
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px dashed var(--medium-gray);
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid .detail-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: var(--text-color);
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid .detail-item strong {
  color: #1f2937;
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid .detail-item .client-detail {
  color: #6b7280;
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid .detail-item .detail-icon {
  color: var(--primary-color);
  font-size: 1.2rem;
}
.my-clients-wrapper .clients-container .client-card-main .section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.my-clients-wrapper .clients-container .client-card-main .section-title .section-icon {
  color: var(--primary-color);
  font-size: 1.3rem;
}
.my-clients-wrapper .clients-container .client-card-main .client-address p {
  line-height: 1.6;
  margin: 0;
  color: var(--text-color);
  font-size: 0.95rem;
}
.my-clients-wrapper .clients-container .client-card-main .client-address p .client-detail {
  color: #6b7280;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-counts {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
  font-size: 0.95rem;
  color: var(--text-color);
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-counts span .client-detail {
  color: var(--primary-color);
  font-weight: 600;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-list {
  margin-top: 0.5rem;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-list strong {
  display: block;
  margin-bottom: 0.3rem;
  color: #1f2937;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-list ul {
  list-style-type: disc;
  padding-left: 1.2rem;
  margin: 0;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-list ul li {
  color: var(--text-color);
  font-size: 0.9rem;
  line-height: 1.4;
}
.my-clients-wrapper .clients-container .no-clients-message {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}
.my-clients-wrapper .pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 4px 10px;
  background-color: #e2e8f0;
  border-radius: 6px;
}
.my-clients-wrapper .pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 0.85rem;
  font-weight: 400;
}
.my-clients-wrapper .pagination-settings #clientPerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 3px 25px 3px 3px;
  background-color: white;
  font-size: 0.85rem;
  color: #333;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.my-clients-wrapper .pagination-settings #clientPerPageSelect:hover {
  background-color: #fafafa;
}
.my-clients-wrapper .pagination-settings #clientPerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.my-clients-wrapper .pagination-settings #clientPerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
  .clients-container {
    padding: 1rem;
  }
  .clients-container .client-card-main {
    padding: 1.5rem;
  }
  .clients-container .client-card-main .client-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.8rem;
  }
  .clients-container .client-card-main .client-header .client-name {
    font-size: 1.5rem;
  }
  .clients-container .client-card-main .client-header .client-actions {
    align-self: flex-end;
    width: 100%;
  }
  .clients-container .client-card-main .client-header .client-actions .client-action-button {
    width: 100%;
    justify-content: center;
  }
  .clients-container .client-card-main .client-header .client-actions .dropdown-menu {
    width: 100%;
    left: 0;
    right: auto;
    transform: translateX(0);
    text-align: center;
  }
  .clients-container .client-card-main .client-details-grid {
    grid-template-columns: 1fr;
  }
  .clients-container .client-card-main .client-address p,
  .clients-container .client-card-main .client-address ul,
  .clients-container .client-card-main .client-cases p,
  .clients-container .client-card-main .client-cases ul {
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .clients-container {
    padding: 0.5rem;
  }
  .clients-container .client-card-main {
    padding: 1rem;
  }
  .clients-container .client-card-main .client-name {
    font-size: 1.3rem;
  }
  .clients-container .client-card-main .section-title {
    font-size: 1rem;
  }
  .clients-container .client-card-main .detail-item,
  .clients-container .client-card-main .client-address p,
  .clients-container .client-card-main .client-cases .case-counts span,
  .clients-container .client-card-main .client-cases .case-list ul li {
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/MyClients/MyClients.scss"],"names":[],"mappings":"AAAA,mBAAA;AAEA;EACE,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mCAAA;EACA,oCAAA;AAAF;;AAIE;EACE,cAAA;EACA,kBAAA;AADJ;AAIE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAFN;AAIM;EACE,eAAA;EACA,cAAA;AAFR;AAKM;EACE,yBAAA;AAHR;AAMM;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAJR;AASE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAPJ;AASI;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EAEA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AARN;AAUM;EACE,yBAAA;AARR;AAUQ;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AARV;AAeQ;EACE,sCAAA;AAbV;AAeU;EACE,yBAAA;AAbZ;AAgBU;EACE,oBAAA;AAdZ;AAmBU;EACE,mBAAA;AAjBZ;AAmBY;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAjBd;AAmBc;EACE,yBAAA;AAjBhB;AAoBc;EACE,YAAA;AAlBhB;AA0BI;EACE,gCAAA;EACA,qCAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AAxBN;AA0BM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4CAAA;AAxBR;AA0BQ;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAxBV;AA2BQ;EACE,kBAAA;AAzBV;AA2BU;EACE,sCAAA;EACA,qCAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,4DAAA;AAzBZ;AA2BY;EAEE,0CAAA;AA1Bd;AA6BY;EACE,iBAAA;AA3Bd;AA+BU;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EAEA,gBAAA;EAEA,YAAA;EACA,gBAAA;AA/BZ;AAiCY;EACE,uBAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;AA/Bd;AAiCc;EACE,mCAAA;AA/BhB;AAkCc;EACE,2CAAA;AAhChB;AAmCc;EACE,cAAA;AAjChB;AAqCc;EACE,cAAA;AAnChB;AAuCc;EACE,cAAA;AArChB;AAyCc;EACE,cAAA;AAvChB;AAgDM;EACE,aAAA;EACA,2DAAA;EAIA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,4CAAA;AAjDR;AAmDQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AAjDV;AAmDU;EACE,cAAA;AAjDZ;AAoDU;EACE,cAAA;AAlDZ;AAqDU;EACE,2BAAA;EACA,iBAAA;AAnDZ;AAwDM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAtDR;AAwDQ;EACE,2BAAA;EACA,iBAAA;AAtDV;AA2DQ;EACE,gBAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;AAzDV;AA2DU;EACE,cAAA;AAzDZ;AA+DQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AA7DV;AAgEY;EACE,2BAAA;EACA,gBAAA;AA9Dd;AAmEQ;EACE,kBAAA;AAjEV;AAmEU;EACE,cAAA;EACA,qBAAA;EACA,cAAA;AAjEZ;AAoEU;EACE,qBAAA;EACA,oBAAA;EACA,SAAA;AAlEZ;AAoEY;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;AAlEd;AAyEI;EAUE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AAhFN;AAoFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAlFJ;AAoFI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAlFN;AAqFI;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EAKA,gBAAA;EAEA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAEA,yBAAA;EACA,2BAAA;AAvFN;AAyFM;EACE,yBAAA;AAvFR;AA0FM;EACE,wDAAA;EACA,uBAAA;AAxFR;AA2FM;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAzFR;;AA+FA,qCAAA;AACA;EACE;IACE,aAAA;EA5FF;EA8FE;IACE,eAAA;EA5FJ;EA8FI;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EA5FN;EA8FM;IACE,iBAAA;EA5FR;EA+FM;IACE,oBAAA;IACA,WAAA;EA7FR;EA+FQ;IACE,WAAA;IACA,uBAAA;EA7FV;EAgGQ;IACE,WAAA;IACA,OAAA;IACA,WAAA;IACA,wBAAA;IACA,kBAAA;EA9FV;EAmGI;IACE,0BAAA;EAjGN;EAsGM;;;;IAEE,iBAAA;EAlGR;AACF;AAwGA;EACE;IACE,eAAA;EAtGF;EAwGE;IACE,aAAA;EAtGJ;EAwGI;IACE,iBAAA;EAtGN;EAyGI;IACE,eAAA;EAvGN;EA0GI;;;;IAIE,kBAAA;EAxGN;AACF","sourcesContent":["/* MyClients.scss */\r\n\r\n:root {\r\n  --text-color: #374151;\r\n  --light-gray: #f3f4f6;\r\n  --medium-gray: #e5e7eb;\r\n  --border-color: #d1d5db;\r\n  --card-bg: #ffffff;\r\n  --shadow-light: rgba(0, 0, 0, 0.05);\r\n  --shadow-medium: rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.my-clients-wrapper {\r\n  .filter-group label {\r\n    display: block;\r\n    margin-bottom: 8px; // Adjust as needed\r\n  }\r\n\r\n  .view-toggle-wrapper {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    align-items: center;\r\n\r\n    .view-toggle-btn {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.3rem;\r\n      padding: 0.3rem 0.6rem;\r\n      font-size: 0.85rem;\r\n      font-weight: 500;\r\n      background-color: transparent;\r\n      color: #444;\r\n      border: 1px solid var(--border-color);\r\n      border-radius: 6px;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n\r\n      svg {\r\n        font-size: 1rem;\r\n        color: inherit;\r\n      }\r\n\r\n      &:hover {\r\n        background-color: #f3f4f6;\r\n      }\r\n\r\n      &.active {\r\n        background-color: #e5e7eb;\r\n        color: #222;\r\n        border-color: #cbd5e1;\r\n      }\r\n    }\r\n  }\r\n\r\n  .clients-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\r\n    gap: 1rem;\r\n    padding: 15px;\r\n    background-color: #f8f9fa;\r\n    box-sizing: border-box;\r\n    margin-top: 1rem;\r\n\r\n    .clients-table {\r\n      width: 100%;\r\n      border-collapse: collapse;\r\n      background-color: var(--card-bg);\r\n      // border: 1px solid var(--border-color);\r\n      border-radius: 0.5rem;\r\n      overflow: hidden;\r\n      font-size: 0.95rem;\r\n      box-shadow: 0 2px 6px var(--shadow-light);\r\n\r\n      thead {\r\n        background-color: #f1f5f9;\r\n\r\n        th {\r\n          text-align: left;\r\n          padding: 1rem;\r\n          color: #111827;\r\n          // border-bottom: 1px solid var(--medium-gray);\r\n          // border: 1px solid #ddd;\r\n        }\r\n      }\r\n\r\n      tbody {\r\n        tr {\r\n          transition: background-color 0.2s ease;\r\n\r\n          &:hover {\r\n            background-color: #f9fafb;\r\n          }\r\n\r\n          td {\r\n            padding: 0.9rem 1rem;\r\n            // border-bottom: 1px solid var(--medium-gray);\r\n            // border: 1px solid #ddd;\r\n          }\r\n\r\n          td:last-child {\r\n            white-space: nowrap;\r\n\r\n            button {\r\n              margin-right: 0.5rem;\r\n              padding: 0.3rem 0.6rem;\r\n              font-size: 0.85rem;\r\n              border: none;\r\n              border-radius: 4px;\r\n              cursor: pointer;\r\n              background-color: #17a2b8;\r\n              color: white;\r\n\r\n              &:last-child {\r\n                background-color: #dc2626; // red for delete\r\n              }\r\n\r\n              &:hover {\r\n                opacity: 0.9;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .client-card-main {\r\n      background-color: var(--card-bg);\r\n      border: 1px solid var(--border-color);\r\n      border-radius: 0.75rem;\r\n      padding: 1rem;\r\n      position: relative;\r\n\r\n      .client-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        margin-bottom: 1rem;\r\n        padding-bottom: 0.5rem;\r\n        border-bottom: 1px dashed var(--medium-gray);\r\n\r\n        .client-name {\r\n          font-size: 1.1rem;\r\n          font-weight: 700;\r\n          color: #1f2937;\r\n          margin: 0;\r\n        }\r\n\r\n        .client-actions {\r\n          position: relative;\r\n\r\n          .client-action-button {\r\n            background-color: var(--primary-color);\r\n            border: 1px solid var(--border-color);\r\n            border-radius: 0.5rem;\r\n            padding: 8px 12px;\r\n            font-size: 0.8rem;\r\n            color: var(--text-color);\r\n            font-weight: 500;\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 0.4rem;\r\n            cursor: pointer;\r\n            transition: background-color 0.2s ease, box-shadow 0.2s ease;\r\n\r\n            &:hover {\r\n              // background-color: var(--medium-gray);\r\n              box-shadow: 0 1px 4px var(--shadow-medium);\r\n            }\r\n\r\n            svg {\r\n              font-size: 1.1rem; // Slightly larger icon\r\n            }\r\n          }\r\n\r\n          .dropdown-menu {\r\n            position: absolute;\r\n            top: 3rem; // Adjust dropdown position\r\n            right: 0;\r\n            background-color: var(--card-bg);\r\n            border: 1px solid var(--border-color);\r\n            border-radius: 0.5rem;\r\n            // box-shadow: 0 6px 16px var(--shadow-medium); \r\n            min-width: 180px;\r\n            // padding: 0.5rem 0;\r\n            z-index: 100;\r\n            list-style: none; // Remove bullet points\r\n\r\n            li {\r\n              padding: 0.75rem 1.2rem; // More padding\r\n              font-size: 0.9rem; // Clearer font size\r\n              color: var(--text-color);\r\n              cursor: pointer;\r\n              transition: background-color 0.2s ease;\r\n              display: flex;\r\n              align-items: center;\r\n\r\n              &:hover {\r\n                background-color: var(--light-gray);\r\n              }\r\n\r\n              &:not(:last-child) {\r\n                border-bottom: 1px solid var(--medium-gray); // Lighter separator\r\n              }\r\n\r\n              &.view {\r\n                color: #2563eb;\r\n              }\r\n\r\n              // Blue\r\n              &.update {\r\n                color: #10b981;\r\n              }\r\n\r\n              // Green\r\n              &.delete {\r\n                color: #ef4444;\r\n              }\r\n\r\n              // Red\r\n              &.message {\r\n                color: #8b5cf6;\r\n              }\r\n\r\n              // Violet\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .client-details-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(\r\n          auto-fit,\r\n          minmax(280px, 1fr)\r\n        ); // Responsive grid\r\n        gap: 1rem;\r\n        margin-bottom: 1rem;\r\n        padding-bottom: 1rem;\r\n        border-bottom: 1px dashed var(--medium-gray);\r\n\r\n        .detail-item {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 0.5rem;\r\n          font-size: 0.95rem;\r\n          color: var(--text-color);\r\n\r\n          strong {\r\n            color: #1f2937; // Darker for labels\r\n          }\r\n\r\n          .client-detail {\r\n            color: #6b7280;\r\n          }\r\n\r\n          .detail-icon {\r\n            color: var(--primary-color);\r\n            font-size: 1.2rem;\r\n          }\r\n        }\r\n      }\r\n\r\n      .section-title {\r\n        font-size: 1rem;\r\n        font-weight: 600;\r\n        color: #1f2937;\r\n        margin-bottom: 0.8rem;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.5rem;\r\n\r\n        .section-icon {\r\n          color: var(--primary-color);\r\n          font-size: 1.3rem;\r\n        }\r\n      }\r\n\r\n      .client-address {\r\n        p {\r\n          line-height: 1.6;\r\n          margin: 0;\r\n          color: var(--text-color);\r\n          font-size: 0.95rem;\r\n\r\n          .client-detail {\r\n            color: #6b7280;\r\n          }\r\n        }\r\n      }\r\n\r\n      .client-cases {\r\n        .case-counts {\r\n          display: flex;\r\n          gap: 1.5rem;\r\n          margin-bottom: 1rem;\r\n          font-size: 0.95rem;\r\n          color: var(--text-color);\r\n\r\n          span {\r\n            .client-detail {\r\n              color: var(--primary-color);\r\n              font-weight: 600;\r\n            }\r\n          }\r\n        }\r\n\r\n        .case-list {\r\n          margin-top: 0.5rem;\r\n\r\n          strong {\r\n            display: block;\r\n            margin-bottom: 0.3rem;\r\n            color: #1f2937;\r\n          }\r\n\r\n          ul {\r\n            list-style-type: disc; // Use regular disc bullets\r\n            padding-left: 1.2rem;\r\n            margin: 0;\r\n\r\n            li {\r\n              color: var(--text-color);\r\n              font-size: 0.9rem;\r\n              line-height: 1.4;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .no-clients-message {\r\n      // text-align: center;\r\n      // font-size: 1.1rem;\r\n      // color: #6b7280;\r\n      // padding: 2rem;\r\n      // background-color: var(--card-bg);\r\n      // border: 1px dashed var(--border-color);\r\n      // border-radius: 0.75rem;\r\n      // margin-top: 2rem;\r\n      // width: 100%;\r\n      text-align: center;\r\n      font-size: 1.1rem;\r\n      color: var(--text-color-medium);\r\n      padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\r\n      background: var(--card-bg);\r\n      border-radius: 0.75rem;\r\n      border: 1px dashed var(--border-color);\r\n      box-shadow: 0 2px 5px var(--shadow-light);\r\n      margin-top: calc(var(--spacing-unit) * 2);\r\n      grid-column: 1 / -1;\r\n    }\r\n  }\r\n\r\n  .pagination-settings {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    padding: 4px 10px;\r\n    background-color: #e2e8f0;\r\n    border-radius: 6px;\r\n\r\n    label {\r\n      white-space: nowrap;\r\n      color: #1f2937;\r\n      font-size: 0.85rem;\r\n      font-weight: 400;\r\n    }\r\n\r\n    #clientPerPageSelect {\r\n      border: none;\r\n      border-radius: 6px;\r\n      outline: none;\r\n      padding: 3px 25px 3px 3px;\r\n      background-color: white;\r\n      font-size: 0.85rem;\r\n      color: #333;\r\n      cursor: pointer;\r\n      // min-width: 70px;\r\n\r\n      -webkit-appearance: none;\r\n      -moz-appearance: none;\r\n      appearance: none;\r\n\r\n      background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n      background-repeat: no-repeat;\r\n      background-position: right 10px center;\r\n      background-size: 16px;\r\n\r\n      transition: all 0.2s ease;\r\n      box-shadow: none !important;\r\n\r\n      &:hover {\r\n        background-color: #fafafa;\r\n      }\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\r\n        background-color: white;\r\n      }\r\n\r\n      option {\r\n        border: none !important;\r\n        outline: none;\r\n        padding: 4px 8px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Media Queries for Responsiveness */\r\n@media (max-width: 768px) {\r\n  .clients-container {\r\n    padding: 1rem;\r\n\r\n    .client-card-main {\r\n      padding: 1.5rem;\r\n\r\n      .client-header {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 0.8rem;\r\n\r\n        .client-name {\r\n          font-size: 1.5rem;\r\n        }\r\n\r\n        .client-actions {\r\n          align-self: flex-end;\r\n          width: 100%; // Make actions button take full width on smaller screens\r\n\r\n          .client-action-button {\r\n            width: 100%;\r\n            justify-content: center;\r\n          }\r\n\r\n          .dropdown-menu {\r\n            width: 100%;\r\n            left: 0;\r\n            right: auto;\r\n            transform: translateX(0); // Reset transform if any\r\n            text-align: center; // Center dropdown items\r\n          }\r\n        }\r\n      }\r\n\r\n      .client-details-grid {\r\n        grid-template-columns: 1fr; // Stack items on smaller screens\r\n      }\r\n\r\n      .client-address,\r\n      .client-cases {\r\n        p,\r\n        ul {\r\n          font-size: 0.9rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .clients-container {\r\n    padding: 0.5rem;\r\n\r\n    .client-card-main {\r\n      padding: 1rem;\r\n\r\n      .client-name {\r\n        font-size: 1.3rem;\r\n      }\r\n\r\n      .section-title {\r\n        font-size: 1rem;\r\n      }\r\n\r\n      .detail-item,\r\n      .client-address p,\r\n      .client-cases .case-counts span,\r\n      .client-cases .case-list ul li {\r\n        font-size: 0.85rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
